import { grey } from "@mui/material/colors";

const styles = {
  select: {
    fontSize: 14,
    color: grey[600],
    ".MuiSelect-select": {
      p: 0,
    },
  },
  menuItem: {
    whiteSpace: "normal",
    maxWidth: 360,
  },
};

export default styles;
